import React, { useEffect } from 'react';
import './EbookModal.scss';
import { safeHtml } from '../../../../services/helpers';
import useEbookForm from '../../../../hooks/useEbookForm';
import SvgIcons from '../../../../services/SvgIcons';
import { useAuth } from '../../../../contexts/AuthContext';

export default function EbookModal({ content, onClose, downloadLink, setNotification }) {
    const { user } = useAuth();
    const {
        values,
        errors,
        isSubmitting,
        submitSuccess,
        submitMessage,
        userEmail,
        handleChange,
        handleSubmit
    } = useEbookForm({ setNotification, downloadLink, user });

    useEffect(() => {
        // Désactiver le scroll du body quand le composant est monté
        document.body.style.overflow = 'hidden';

        // Réactiver le scroll quand le composant est démonté
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    // Chargement du script reCAPTCHA v3
    useEffect(() => {
        if (!window.grecaptcha) {
            const loadRecaptcha = () => {
                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
                script.async = true;
                document.head.appendChild(script);
            };
            loadRecaptcha();
        }
    }, []);

    return (
        <div className="ebook-modal" onClick={handleOverlayClick}>
            <div className="ebook-modal__content">
                <SvgIcons
                    name={'close'}
                    width={50}
                    height={50}
                    color={'#eee6db'}
                    onClick={onClose}
                    cursor={'pointer'}
                    position={'absolute'}
                    top={10}
                    right={10}
                />
                <div className="ebook-modal__header">
                    <picture className='ebook-modal__logo'>
                        <source srcSet={'/assets/logo_white.webp'} type="image/webp" />
                        <img src={'/assets/logo_white.png'} alt="Logo Grandir & s'élever ensemble" loading="eager" fetchpriority="high" />
                    </picture>
                    <h2 className="ebook-modal__title">
                        {submitSuccess ? 'Merci !' : 'Télécharge ton e-book gratuit'}
                    </h2>
                </div>

                {submitSuccess ? (
                    <div className="ebook-modal__success">
                        <p>Un mail avec le lien de téléchargement a été envoyé à l'adresse <b>{userEmail}</b></p>
                        <p><i>N'oublie pas de vérifier les courriers indésirables.</i></p>
                        <div className="ebook-thanks__text" dangerouslySetInnerHTML={safeHtml(content.Remerciements.Texte)} />
                    </div>
                ) : (
                    <form className="ebook-modal__form" onSubmit={handleSubmit}>
                        <div className="ebook-modal__field">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={values.email}
                                onChange={handleChange}
                                disabled={isSubmitting}
                                className={`ebook-modal__input ${errors.email ? 'ebook-modal__input--error' : ''}`}
                            />
                            {errors.email && (
                                <span className="ebook-modal__error">{errors.email}</span>
                            )}
                        </div>

                        <div className="ebook-modal__field">
                            <input
                                type="text"
                                name="prenom"
                                placeholder="Prénom"
                                value={values.prenom}
                                onChange={handleChange}
                                disabled={isSubmitting}
                                className={`ebook-modal__input ${errors.prenom ? 'ebook-modal__input--error' : ''}`}
                            />
                            {errors.prenom && (
                                <span className="ebook-modal__error">{errors.prenom}</span>
                            )}
                        </div>

                        <div className="ebook-modal__field">
                            <input
                                type="text"
                                name="codePostal"
                                placeholder="Code postal"
                                value={values.codePostal}
                                onChange={handleChange}
                                disabled={isSubmitting}
                                className={`ebook-modal__input ${errors.codePostal ? 'ebook-modal__input--error' : ''}`}
                            />
                            {errors.codePostal && (
                                <span className="ebook-modal__error">{errors.codePostal}</span>
                            )}
                        </div>

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="ebook-modal__submit"
                        >
                            {isSubmitting ? 'TÉLÉCHARGEMENT...' : 'TÉLÉCHARGER'}
                        </button>
                    </form>
                )}
                {
                    !submitSuccess &&
                    <>
                        <p className="ebook-modal__newsletter">
                            En téléchargeant cet ebook, j’accepte de recevoir les newsletters et les offres exclusives de Mélanie ✨ Grandir & s'élever ensemble
                        </p>
                        <p className="ebook-modal__privacy">
                            Ton adresse email ne sera jamais partagée
                        </p>
                    </>
                }
            </div>
        </div>
    );
}